import type { Row } from '@tanstack/react-table';
import type { TableRow } from '../types/table-row-types';
import { CreditNoteRow, InvoiceRow } from '.';

type BalanceSubRowsProps = {
  row: Row<TableRow>;
};

export const BalanceSubRows = ({ row }: BalanceSubRowsProps) => {
  const { type } = row.original;

  if (type === 'invoice' && row.original.invoices)
    return <InvoiceRow invoice={row.original.invoices} />;
  if (type === 'credit_note' && row.original.creditNotes)
    return <CreditNoteRow creditNote={row.original.creditNotes} />;

  return null;
};
